import { ListingType as DbListingType } from "@redotech/cockroachdb-codegen/tables/product/listing-type";
import {
  productFamilyIdFormat,
  productIdFormat,
} from "@redotech/redo-product-id";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export enum ListingType {
  General = "general",
  Shopify = "shopify",
  ChatGpt = "chatgpt",
  Amazon = "amazon",
  Walmart = "walmart",
  Perplexity = "perplexity",
  RedoMarketplace = "redo-marketplace",
  Ebay = "ebay",
  GoogleShopping = "google-shopping",
}
export const ListingTypeSchema = createEnum(ListingType);

export const BaseProductFamilyListingSchema = z.object({
  listingType: ListingTypeSchema,
  productFamilyId: productFamilyIdFormat.schema,
});

export const BaseProductListingSchema = z.object({
  listingType: ListingTypeSchema,
  productId: productIdFormat.schema,
});

const ListingTypeToDbListingType: Record<ListingType, DbListingType> = {
  [ListingType.General]: DbListingType.General,
  [ListingType.Shopify]: DbListingType.Shopify,
  [ListingType.ChatGpt]: DbListingType.Chatgpt,
  [ListingType.Amazon]: DbListingType.Amazon,
  [ListingType.Walmart]: DbListingType.Walmart,
  [ListingType.Perplexity]: DbListingType.Perplexity,
  [ListingType.RedoMarketplace]: DbListingType.RedoMarketplace,
  [ListingType.Ebay]: DbListingType.Ebay,
  [ListingType.GoogleShopping]: DbListingType.GoogleShopping,
};

const DbListingTypeToListingType: Record<DbListingType, ListingType> =
  Object.fromEntries(
    Object.entries(ListingTypeToDbListingType).map(
      ([listingType, dbListingType]) => [
        dbListingType,
        listingType as ListingType,
      ],
    ),
  ) as Record<DbListingType, ListingType>;

export function getDbListingType(listingType: ListingType): DbListingType {
  return ListingTypeToDbListingType[listingType];
}

export function getListingType(dbListingType: DbListingType): ListingType {
  return DbListingTypeToListingType[dbListingType];
}
